import { render, staticRenderFns } from "./MallEventUploadCsv.vue?vue&type=template&id=1a90eab1&scoped=true&"
import script from "./MallEventUploadCsv.vue?vue&type=script&lang=js&"
export * from "./MallEventUploadCsv.vue?vue&type=script&lang=js&"
import style0 from "./MallEventUploadCsv.vue?vue&type=style&index=0&id=1a90eab1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90eab1",
  null
  
)

export default component.exports